import * as React from 'react';
import { Divider, Text } from '@grandvisionhq/elements';

const SubscriptionHeader = ({ header  })=>/*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__subscription-header"
    }, /*#__PURE__*/ React.createElement(Divider, {
        theme: "light"
    }), /*#__PURE__*/ React.createElement(Text, {
        className: "cart-totals__subscription-header-text",
        component: "span",
        variant: "body-head"
    }, header))
;

export { SubscriptionHeader };
//# sourceMappingURL=SubscriptionHeader.js.map
